// Each opening is a separate draft. Manual field edits win over delayed speech.
let nextFormId = 0;
export function createFormEditGuard() {
  let id = null, edits = {};
  return {
    open() { if (!id) { id = String(++nextFormId); edits = {}; } },
    close() { id = null; edits = {}; },
    manual(field) { edits[field] = (edits[field] || 0) + 1; },
    snapshot() { return id ? {id, edits:{...edits}} : null; },
    filter(fields, expected) {
      if (!id || !expected || expected.id !== id) return null;
      return Object.fromEntries(Object.entries(fields).filter(([key]) => (edits[key] || 0) === (expected.edits?.[key] || 0)));
    }
  };
}
export const FORM_FIELDS = {
  save:['name','email','phone'],
  showing:['name','email','phone','date','time'],
  seller_review:['name','email','phone','address','location','property_details']
};
const contextKeys = {save:['save_form','save_draft'],showing:['showing_form','showing_draft'],seller_review:['seller_form','seller_review_draft']};
export function activeVoiceForm(ui) {
  const keys = contextKeys[ui.screen];
  if (!keys || !ui[keys[0]] || ui.save_busy || (ui.screen==='showing' && (ui.showing_status==='sent' || ui.showing_submitting)) || (ui.screen==='seller_review' && ui.seller_review_status!=='review')) return null;
  const draft = Object.fromEntries(FORM_FIELDS[ui.screen].map(key=>[key,ui[keys[1]]?.[key] || '']));
  const invalid = key => !draft[key].trim() || (key==='email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(draft[key])) || (key==='phone' && !/^\d{7,15}$/.test(draft[key].replace(/\D/g,'')));
  return {kind:ui.screen, ...ui[keys[0]], draft, expected_field:FORM_FIELDS[ui.screen].find(invalid) || null};
}
export function sameVoiceForm(first, second) { return Boolean(first && second && first.kind===second.kind && first.id===second.id); }

export async function requestVoiceFormPatch({text, form, ui, voiceSessionId}) {
  const {getAssistantVisitor, readAssistantResponse} = await import('./assistantApi');
  const {SITE_CONFIG} = await import('../config');
  const {token} = await getAssistantVisitor();
  const abort = new AbortController();
  const timeout = setTimeout(() => abort.abort(), 20000);
  try {
  const response = await fetch('https://tophamtechbe.com/llm/v1/chat', {
    signal:abort.signal,method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${token}`},
    body:JSON.stringify({message:text,site_id:SITE_CONFIG.SITE_ID,voice_session_id:voiceSessionId,
      capabilities:['assistant_ui_v1','assistant_form_fill_v1'],
      form_fill:{kind:form.kind,draft:form.draft,expected_field:form.expected_field},ui_context:ui})
  });
  await readAssistantResponse(response);
  const data=await response.json(), patch=data.form_patch;
  if (!patch || patch.kind!==form.kind || !['update','other','clarify'].includes(patch.intent) || !patch.fields || typeof patch.fields!=='object' || Array.isArray(patch.fields) || Object.entries(patch.fields).some(([key,value])=>!FORM_FIELDS[form.kind].includes(key) || typeof value!=='string')) throw new Error('Voice form entry could not read those details. Please repeat them or type them in the form.');
  if (patch.intent==='update' && !Object.keys(patch.fields).length) throw new Error('No form changes were received. Please repeat the detail.');
  if (patch.intent!=='update' && Object.keys(patch.fields).length) throw new Error('The form response was invalid. Please repeat the detail.');
  return patch;
  } catch (error) {
    if (error.name === 'AbortError') throw new Error('Voice entry took too long. Please repeat that detail or type it in the form.');
    throw error;
  } finally { clearTimeout(timeout); }
}
